import { FC, useEffect } from 'react'
import ROUTES from '@client-hub/shared/constants/routes'
import { useHubTokenValidation } from 'hooks/auth'
import RouteGuardBase from 'components/RouteGuardBase'
import HubSessionTimer from './HubSessionTimer'
import groundcover from '@groundcover/browser'
import { selectCrsEmail, selectCrsUserId, selectCrsFullName } from '@client-hub/store/slices/metadata/selectors'
import { useSelector } from 'react-redux'

const HubAuthGuard: FC = (props) => {
  const [isValid, { isLoading }] = useHubTokenValidation()
  const email = useSelector(selectCrsEmail)
  const userId = useSelector(selectCrsUserId)
  const name = useSelector(selectCrsFullName)

  useEffect(() => {
    if (isValid) {
      groundcover.identifyUser({
        id: userId,
        email: email,
      })
      groundcover.updateConfig({
        userIdentifier: { name: name },
      })
    }
  }, [isValid, userId, email, name])

  return (
    <RouteGuardBase {...props} loading={isLoading} redirect={!isValid} redirectTo={ROUTES.LOGIN.BASE}>
      <HubSessionTimer />
      {props.children}
    </RouteGuardBase>
  )
}

export default HubAuthGuard
